<template>
    <div class="must-have-exactly-one-root-element">

        <!-- Header -->
        <header-profil
            @updateProfil="emitUpdateProfil"
            :profil="profil"
        />

        <!-- Main -->
        <main class="profileDashboard">
            <div class="container">
                <div class="row">

                    <!-- Menu -->
                    <menu-profil
                        :profil="profil"
                        :spravy="spravy"
                    />

                    <!-- Kravičky -->
                    <div v-if="profil.pouzivatel_id" class="col-xs-12 col-md-12 col-lg-12 col-xl-9">
                        <h2>Moje kravičky</h2>

                        <!-- Alert box -->
                        <div v-if="responseText != ''" :class="'alert alert-'+responseType" role="alert">
                            <span :class="'icon --'+responseType"></span>{{ responseText }}
                        </div>

                        <!-- Adoptovať kravičku -->
                        <div v-if="!profil.pouzivatel_id.kravicky_pouzivatela.length && profil.pouzivatel_id.pouzivatel_group === 1" class="o-banner --small d-flex">
                            <div class="m-banner__left">
                                <h3 class="a-banner__title">Adoptuj si svoju prvú kravičku</h3>
                                <p class="a-banner__description">Na výber je ešte <span class="count">{{ volneKravicky }}</span>

                                    <!-- Skloňovanie -->
                                    <span v-if="volneKravicky == 1">
                                        kravička
                                    </span>
                                    <span v-if="volneKravicky > 1 && volneKravicky < 5">
                                        kravičky
                                    </span>
                                    <span v-else>
                                        kravičiek
                                    </span>
                                    <!-- .Skloňovanie -->

                                </p>
                            </div>

                            <div class="m-banner__btn">
                                <!--TODO migracia URL-->
                                <a href="https://adoptujkravicku.sk/kravicky/" class="btn --primary">
                                    Vyber si kravičku
                                </a>
                            </div>
                        </div>
                        <!-- .Adoptovať kravičku -->

                        <div class="row">

                            <!-- Cow Box -->
                            <template v-if="profil.pouzivatel_id.kravicky_pouzivatela.length">
                                <div v-for="(kravicka, index) in profil.pouzivatel_id.kravicky_pouzivatela" class="col-12 col-sm-12 col-md-6 col-lg-4">
                                    <!-- Adoptovana -->
                                    <div v-if="kravicka.kravicka_status == 2" class="o-cowCard mb-3 mb-sm-3 mb-md-3">

                                        <!-- Img hlava -->
                                        <div
                                                class="m-cowCard__image"
                                                :style="[{'background-image': 'url(assets/img/produkty/background/' + kravicka.kravicka_pozadie_profil + ')'}]"
                                        >
                                            <img :src="'https://www.adoptujkravicku.sk/data/foto/' +  kravicka.kravicka_img_hlava" alt="" class="a-cowCard_head img-fluid">
                                        </div>

                                        <!-- Meno + HP + Farma -->
                                        <div class="m-cowCard__body">
                                            <h4 class="a-cowCard__title">{{ kravicka.kravicka_meno }}</h4>
                                            <div class="a-cowCard__health">
                                                <span class="icon-heart"></span>{{ roundNumber(kravicka.kravicka_param_global) }}%
                                            </div>

                                            <!-- Pridať / Odobrať -->
                                            <div v-if="profil.pouzivatel_id.farma_pouzivatela.length != 0">

                                            <span v-if="kravicka.farma_kravicka.length">
                                                <div v-if="btnText[index] == 1" class="a-cowCard__add" @click="addCowToFarm(index, kravicka.id)">
                                                    <router-link :to="{ name: 'kravicky' }">
                                                        <span class="icon-plus"></span>Pridať na farmu
                                                    </router-link>
                                                </div>
                                                <div v-else class="a-cowCard__remove" @click="removeCowFromFarm(index, kravicka.id)">
                                                    <router-link :to="{ name: 'kravicky' }">
                                                        <span class="icon-close"></span>Odstrániť z farmy
                                                    </router-link>
                                                </div>
                                            </span>
                                                <span v-else>
                                                <div v-if="btnText[index] == 0" class="a-cowCard__remove" @click="removeCowFromFarm(index, kravicka.id)">
                                                    <router-link :to="{ name: 'kravicky' }">
                                                        <span class="icon-close"></span>Odstrániť z farmy
                                                    </router-link>
                                                </div>
                                                <div v-else class="a-cowCard__add" @click="addCowToFarm(index, kravicka.id)">
                                                    <router-link :to="{ name: 'kravicky' }">
                                                        <span class="icon-plus"></span>Pridať na farmu
                                                    </router-link>
                                                </div>
                                            </span>

                                            </div>
                                            <!-- .Pridať / Odobrať -->

                                            <router-link :to="{ name: 'kravicka', params: { kravicka_id: kravicka.id } }" class="btn --primary">
                                                Postarať sa
                                            </router-link>
                                        </div>
                                        <!-- .Meno + HP + Farma -->

                                        <!-- CV + Údaje -->
                                        <div class="m-cowCard__buttons">
                                            <a :href="'https://adoptujkravicku.sk/hra/kravicka/rodny-list/' + kravicka.id" class="a-cowCard__birthlist">
                                                <span class="icon"></span>
                                            </a>

                                            <router-link :to="{ name: 'uprava-kravicky', params: { kravicka_id: kravicka.id, kravicka_meno: kravicka.kravicka_meno, kravicka_meno_rodica: kravicka.kravicka_meno_rodica } }" class="a-cowCard__edit">
                                                <span class="icon"></span>
                                            </router-link>
                                        </div>
                                        <!-- .CV + Údaje -->
                                    </div>
                                    <!-- .Adoptovaná -->

                                    <!-- Rezervovaná -->
                                    <div v-if="kravicka.kravicka_status == 1" class="o-cowCard mb-3 mb-sm-3 mb-md-3">

                                        <div class="m-cowCard__image" :style="[kravicka.kravicka_pozadie_profil ? {'background': 'url(' + kravicka.kravicka_pozadie_profil + ')'} : '']">
                                            <img :src="'https://www.adoptujkravicku.sk/data/foto/' +  kravicka.kravicka_img_hlava" alt="" class="a-cowCard_head img-fluid">
                                        </div>

                                        <!-- Meno -->
                                        <div class="m-cowCard__body">
                                            <h4 class="a-cowCard__title">{{ kravicka.kravicka_meno }}</h4>
                                            <div class="a-cowCard__reserved">
                                                <span class="icon"></span>Nedokončená adopcia
                                            </div>

                                            <router-link :to="{ name: 'adopcia-ean', params: { kravicka_id: kravicka.id } }" class="btn --primary">
                                                Pridať EAN
                                            </router-link>
                                        </div>
                                        <!-- .Meno -->

                                        <!-- CV + Údaje -->
                                        <div class="m-cowCard__buttons">
                                            <a :href="'https://adoptujkravicku.sk/hra/kravicka/rodny-list/' + kravicka.id" class="a-cowCard__birthlist">
                                                <span class="icon"></span>
                                            </a>

                                            <router-link :to="{ name: 'uprava-kravicky', params: { kravicka_id: kravicka.id, kravicka_meno: kravicka.kravicka_meno, kravicka_meno_rodica: kravicka.kravicka_meno_rodica } }" class="a-cowCard__edit">
                                                <span class="icon"></span>
                                            </router-link>
                                        </div>
                                        <!-- .CV + Údaje -->
                                    </div>
                                    <!-- .Rezervovaná -->

                                </div>
                            </template>
                            <!-- .Cow Box -->

                            <div v-else-if="profil.pouzivatel_id.pouzivatel_group === 0" class="col-12">
                                <p>Milý kamarát - milá kamarátka hry Adoptuj kravičku,</p>
                                <p>v prvom rade sa Ti chceme poďakovať, že si si kedysi adoptoval skutočnú kravičku z niektorej zo slovenských fariem a že si sa o ňu virtuálne staral.</p>
                                <p>V minulosti bola možnosť raz do roka adoptovanú kravičku navštíviť počas Dňa otvorených dverí. Pandémia koronavírusu však zasiahla aj do tejto krásnej aktivity, situácia neumožnila osobné stretnutie s farmármi a návštevu kravičky.</p>
                                <p>Základným pravidlom hry bola virtuálna starostlivosť o adoptovanú kravičku. V závale iných povinností zrejme mnohé kravičky ostali nepovšimnuté, ich šťastie sa ocitlo na nule. Preto sme sa rozhodli dať kravičkám novú šancu v novej edukačnej hre pre deti v škôlkach a na 1. stupni základných škôl, a to už od septembra 2021.</p>
                                <p>Všetky adoptované kravičky, ktoré boli doteraz v hre a mali nulové šťastie, budú opäť sprístupnené, aby sa o ne mohli starať škôlkari a školáci v rámci nového edukačného projektu určeného len školským kolektívom.</p>
                                <p>Veríme, že na nás nezanevrieš a že kravičky budeš mať stále v obľube. Sú to vzácne zvieratká, ktoré nám dávajú základnú potravinu - mlieko.</p>
                                <p>Ďakujeme ti za doterajšiu starostlivosť.</p>
                                <p>S pozdravom</p>
                                <p>Slovenská mliečna rodina</p>
                            </div>

                        </div>
                    </div>
                    <!-- .Kravičky -->

                </div>
            </div>
        </main>

    </div>
</template>



<script>
    import EventService from '@/services/EventService.js'
    import HeaderProfil from '../partials/HeaderProfil.vue'
    import MenuProfil   from '../partials/MenuProfil.vue'
    export default {
        components: {
            HeaderProfil,
            MenuProfil
        },
        props: [
            'profil',
            'spravy',
            'canAdopt'
        ],
        mounted() {
            this.countKravicky()
        },
        data() {
            return {
                volneKravicky: 0,
                btnText: [],
                isDisabled: false,

                responseType: '',
                responseText: ''
            }
        },
        methods: {
            // emit
            emitUpdateProfil() {
                this.$emit('updateProfil')
            },


            // mounted
            countKravicky() {
                EventService.countKravicky()
                    .then(response => {
                        //console.log(response.data)
                        this.volneKravicky = response.data.data[0].amount
                    })
                    .catch(error => {
                        this.responseType = 'warning'
                        this.responseText = error
                    })
            },


            // round
            roundNumber(value) {
                return Number((value).toFixed(0))
            },


            // click
            addCowToFarm(index, kravicka_id) {
                if (!this.isDisabled) {
                    this.isDisabled = true
                    EventService.addCowToFarm(kravicka_id, this.profil.pouzivatel_id.farma_pouzivatela[0].id, this.profil.pouzivatel_id.farma_pouzivatela[0].herna_farma_kapacita_kraviciek)
                        .then(response => {
                            //console.log(response.data)
                            this.responseType = response.data.code
                            this.responseText = response.data.data

                            if (response.data.code == 'success') {
                                this.btnText[index] = 0
                            }
                            this.isDisabled = false
                        })
                        .catch(error => {
                            this.responseType = 'warning'
                            this.responseText = error
                        })
                }
            },

            removeCowFromFarm(index, kravicka_id) {
                if (!this.isDisabled) {
                    this.isDisabled = true
                    EventService.removeCowFromFarm(kravicka_id, this.profil.pouzivatel_id.farma_pouzivatela[0].id, this.profil.pouzivatel_id.farma_pouzivatela[0].herna_farma_kapacita_kraviciek)
                        .then(response => {
                            //console.log(response.data)
                            this.responseType = response.data.code
                            this.responseText = response.data.data

                            if (response.data.code == 'success') {
                                this.btnText[index] = 1
                            }
                            this.isDisabled = false
                        })
                        .catch(error => {
                            this.responseType = 'warning'
                            this.responseText = error
                        })
                }
            }
        }
    }
</script>
